import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-poker-4",
  "use": "icon-si-glyph-poker-4-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-poker-4\" id=\"icon-si-glyph-poker-4\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>684</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M12.372,0.058 L5.627,0.058 C4.737,0.058 4.014,0.787 4.014,1.682 L4.014,14.371 C4.014,15.267 4.738,15.995 5.627,15.995 L12.372,15.995 C13.263,15.995 13.986,15.266 13.986,14.371 L13.986,1.682 C13.986,0.786 13.263,0.058 12.372,0.058 L12.372,0.058 Z M9.023,11 C9.023,11 6.034,9.544 6.034,6.71 C6.034,5.731 6.712,4.934 7.547,4.934 C8.266,4.934 8.865,5.521 9.022,6.308 C9.172,5.521 9.766,4.934 10.482,4.934 C11.31,4.934 11.981,5.721 11.981,6.694 C11.98,9.58 9.023,11 9.023,11 L9.023,11 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-poker-4.svg
// module id = stQq
// module chunks = 62